import { withLDConsumer } from 'launchdarkly-react-client-sdk';

export function FeatureFlag({ flag, children, fallback = null, flags }) {
  const enabled = flags[flag];

  const render = (node) => (typeof node === 'function' ? node() : node);

  return enabled ? render(children) : render(fallback);
}

export const FeatureFlagWithLD = withLDConsumer()(FeatureFlag);

export function withFeatureFlag(flagKey, NewComponent, OldComponent, defaultValue = false) {
  return withLDConsumer()(function (props) {
    const { flags } = props;
    const enabled = flags && flags[flagKey];
    const flagValue = typeof enabled === 'boolean' ? enabled : defaultValue;

    const enhancedProps = {
      ...props,
      [flagKey]: flagValue,
    };

    if (flags && flags[flagKey]) {
      return <NewComponent {...enhancedProps} />;
    }

    return <OldComponent {...enhancedProps} />;
  });
}
